<template>
  <div>
    <v-card class="border-1 outlined m-1 mt-0 p-1 rental-contract-from">
      <v-container fluid class="mb-0 removed-container" style="">
        <!-- New Design Ends Here -->

        <v-row class="border-b align-center">
          <v-col cols="12" sm="12" md="4">
            <h4 class="text-blue-color d-flex align-center">
              <v-icon class="text-blue-color mr-2" dark right>
                mdi-card-account-details </v-icon
              >{{
                formMode === "add"
                  ? $t("rentals.create_new")
                  : $t("rentals.edit")
              }}
              {{ $t("rentals.rental_contract") }}
            </h4>
          </v-col>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              id="top-print"
              class="ma-2 text-white-color"
              color="primary"
              disabled
              v-if="formMode === 'edit'"
            >
              {{ $t("rentals.print_contract") }}
              <v-icon dark right> mdi-printer </v-icon>
            </v-btn>
            <v-btn
              v-if="formMode === 'edit'"
              @click="attachmentDialog = true"
              id="top-attachments"
              class="ma-2 text-white-color"
              color="success"
            >
              {{ $t("attachments") }} ({{
                $store.state.attachmentCounts["rentals"]
                  ? $store.state.attachmentCounts["rentals"]
                  : 0
              }})
              <v-icon dark right> mdi-paperclip </v-icon>
            </v-btn>

            <v-btn
              id="top-cancel"
              class="ma-2 text-black-color"
              color="grey lighten-2"
              @click="cancelRental"
            >
              {{ $t("nav_buttons.cancel") }}
              <v-icon dark right> mdi-keyboard-return </v-icon>
            </v-btn>
            <v-btn
              id="top-save"
              class="ma-2 text-white-color"
              color="success"
              @click="saveData"
            >
              {{ $t("nav_buttons.save") }}
              <v-icon dark right> mdi-content-save </v-icon>
            </v-btn>
          </div>
        </v-row>

        <!-- Heading Ends Here -->
        <v-divider class="mt-5"></v-divider>
      </v-container>
      <div>
        <div class="mt-0 removed-container" style="margin: 10px !important">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <h4 class="text-blue-color">
                {{ $t("rentals.contract_details") }}
              </h4>
            </v-col>

            <v-col cols="12" sm="12" md="3">
              <v-text-field
                autocomplete="off"
                v-model="form.identifier"
                class="to-upper"
                name="identifier"
                v-on:keydown="handleInput($event, 'alphanumeric', 100)"
                :label="$t('rentals.identifier')"
                :outlined="is_boxes"
                :dense="is_boxes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-combobox
                autocomplete="off"
                ref="clientName"
                v-model="form.client"
                :items="company_client_names"
                item-value="id"
                item-text="name"
                :label="$t('vehicles.client')"
                class="to-upper"
                required
                append-icon="mdi-close"
                v-on:keydown="handleInput($event, 'everything', 50)"
                :search-input.sync="search_client"
                no-filter
                v-on:keydown.enter.prevent=""
                @click:append="
                  form.client = null;
                  company_client_names = [];
                "
                :error-messages="
                  $store.state.validation && !$v.form.client.required
                    ? [this.$t('vehicles.text_messages.client_required')]
                    : []
                "
                return-object
                :outlined="is_boxes"
                :dense="is_boxes"
              >
                <template slot="selection" slot-scope="{ item }">
                  {{ item.name ? item.name : "" }}
                  {{ item.first_name ? item.first_name : "" }}
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <p class="client_name">
                      {{ item.name ? item.name : "" }}
                      {{ item.first_name ? item.first_name : "" }}
                    </p>
                    <p
                      class="client_detail"
                      v-if="item.representative_company_id"
                    >
                      {{ $t("entity_type.company") }}
                    </p>
                    <p class="client_detail" v-else>
                      {{ $t("entity_type.private") }}
                    </p>
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-combobox
                autocomplete="off"
                ref="propertyName"
                v-model="form.property"
                :items="properties"
                item-value="id"
                item-text="name"
                :label="$t('rentals.property_name')"
                class="to-upper"
                append-icon="mdi-close"
                v-on:keydown="handleInput($event, 'everything', 80)"
                :search-input.sync="search_property"
                no-filter
                v-on:keydown.enter.prevent=""
                @click:append="
                  form.property = null;
                  properties = [];
                "
                return-object
                :outlined="is_boxes"
                :dense="is_boxes"
              >
                <template slot="selection" slot-scope="{ item }">
                  {{ getPropertyName(item) }}
                </template>
                <template slot="item" slot-scope="{ item }">
                  <v-list-item-content>
                    <p class="client_name">
                      {{ getPropertyName(item) }}
                    </p>
                  </v-list-item-content>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                v-model="menuDtpStart"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    :label="$t('rentals.start_date')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:append="form.start_date = null"
                    append-icon="mdi-close"
                    class="mr-2 to-upper"
                    :outlined="is_boxes"
                    :dense="is_boxes"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :first-day-of-week="1"
                  :weekday-format="getDay"
                  v-model="form.start_date"
                  :min="today"
                  @input="menuDtpStart = false"
                  no-title
                  scrollable
                  :locale="userLanguageId"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <v-menu
                v-model="menuDtpEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    :label="$t('rentals.end_date')"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click:append="form.end_date = null"
                    append-icon="mdi-close"
                    class="mr-2 to-upper"
                    :outlined="is_boxes"
                    :dense="is_boxes"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :first-day-of-week="1"
                  :weekday-format="getDay"
                  :min="form.start_date"
                  :max="form.extended_date"
                  v-model="form.end_date"
                  @input="menuDtpEnd = false"
                  no-title
                  scrollable
                  :locale="userLanguageId"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field
                autocomplete="off"
                v-model="form.contract_reference"
                class="to-upper"
                name="client_contract_ref"
                v-on:keydown="handleInput($event, 'alphanumeric', 100)"
                :label="$t('rentals.contract_reference')"
                :outlined="is_boxes"
                :dense="is_boxes"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                autocomplete="off"
                v-model="form.client_reference"
                class="to-upper"
                name="internal_contract_ref"
                v-on:keydown="handleInput($event, 'alphanumeric', 100)"
                :label="$t('rentals.client_reference')"
                :outlined="is_boxes"
                :dense="is_boxes"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-5">
            <v-col cols="12" sm="12" md="12">
              <h4 class="mb-3" style="color: #9b9b9b; font-weight: normal">
                {{ $t("rentals.note") }}
              </h4>
              <wysiwyg v-model="form.note" />
            </v-col>
          </v-row>
          <br />
        </div>
      </div>

      <attachment-dialog
        v-if="attachmentDialog"
        :showDialog.sync="attachmentDialog"
        :data="rentalId"
        :countKey="'rentals'"
        :resource="'rentals'"
      ></attachment-dialog>
    </v-card>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import axios from "@/plugins/axios";
import { API_BASE_URL } from "@/config";
import AttachmentDialog from "@/components/AttachmentDialog";
import moment from "moment";
export default {
  name: "AddPropertyRentalsHistory",
  mixins: [validationMixin],
  components: {
    "attachment-dialog": AttachmentDialog,
  },
  props: {
    showBookingDialog: [Boolean],
  },
  data() {
    return {
      isTrue: true,
      rentalHistory: null,
      rentalId: this.$store.state.rentalId,
      is_edit: (this.$route.path.includes("edit") ? "edit" : "add") === "edit",
      company_client_names: [],
      properties: [],
      autocompleteValueLocal: false,
      search_client: null,
      search_property: null,
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      menuDtp: false,
      menuDtpStart: false,
      menuDtpEnd: false,
      attachmentDialog: false,
      form: {
        identifier: null,
        client: {},
        client_reference: null,
        contract_reference: null,
        property: null,
        property_id: null,
        property_name: null,
        start_date: new Date().toISOString().substr(0, 10),
        end_date: new Date().toISOString().substr(0, 10),
        note: null,
      },
    };
  },
  created() {
    this.fetchPropertiesOnCreate();
    if (this.formMode === "edit") {
      if (!this.rentalId) {
        this.$router.push("/property-rentals");
        return;
      }
      this.setRentalHistory();
    }
  },
  methods: {
    falseButtonClicked() {
      this.$store.commit("setRentalVehicleForm", false);
    },
    showAttachmentDialog() {
      this.attachmentDialog = true;
    },
    getPropertyName(property) {
      if (!property) {
        return "";
      }
      if (typeof property === "string") {
        return property;
      }
      return property.name || property.property_name || "";
    },
    formPayload() {
      return this.makeSumbitData();
    },
    makeSumbitData(){
        return {
            identifier: this.form.identifier,
            client_id: this.form.client.id,
            client_reference: this.form.client_reference,
            contract_reference: this.form.contract_reference,
            property_id: this.form.property_id,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            note: this.form.note,
        }
    },
    setRentalHistory() {
      axios
        .get(API_BASE_URL + "/property_rentals/" + this.rentalId, {
          headers: this.header,
        })
        .finally(() => this.$store.commit("setLoading", false))
        .then((response) => {
          let history = response.data;
          this.rentalHistory = history;
          // Fill Form Data
          this.form = history;
          if (history.property) {
            this.form.property = history.property;
            this.form.property_id = history.property.id || null;
            this.form.property_name = this.getPropertyName(history.property);
          }
          this.form.start_date = moment(history.start_date).format(
            "YYYY-MM-DD"
          );
          this.form.end_date = moment(history.end_date).format("YYYY-MM-DD");
        })
        .catch((error) => {
          this.$toast.error(
            error?.response?.data?.message || this.$t("unknown_error")
          );
        });
    },

    updateData() {
      let payload = this.formPayload();
      axios
        .put(
          API_BASE_URL + "/property_rentals/" + this.$store.state.rentalId,
          payload,
          { headers: this.header }
        )
        .then(() => {
          this.$toast.success(
            this.$t("vehicles.text_messages.contract_updated_successfully")
          );
          this.$store.commit("setRentalVehicleForm", false);
          this.$router.push("/property-rentals");
        })
        .catch((error) => {
          this.$toast.error(
            error?.response?.data?.errors ||
              error?.response?.data?.errors[0] ||
              error?.response?.message ||
              "Unknown error ocurred"
          );
        })
        .finally(() => {});
    },
    addNew() {
      axios
        .post(API_BASE_URL + "/property_rentals", this.formPayload(), {
          headers: this.header,
        })
        .then(() => {
          this.$toast.success(
            this.$t("vehicles.text_messages.contract_created_successfully")
          );
          this.$router.push("/property-rentals");
        })
        .catch((error) => {
          this.$toast.error(
            error?.response?.data?.errors ||
              error?.response?.data?.errors[0] ||
              error?.response?.message ||
              "Unknown error ocurred"
          );
        })
        .finally(() => {});
    },
    saveData() {
      if (!this.form.client || JSON.stringify(this.form.client) === "{}") {
        return this.$toast.error(this.$t("rentals.client_error"));
      }

      if (!this.form.property_name && !this.form.property_id) {
        return this.$toast.error(this.$t("required"));
      }

      if (!this.form.start_date) {
        return this.$toast.error(this.$t("rentals.start_date_error"));
      }

      if (!this.form.end_date) {
        return this.$toast.error(this.$t("rentals.end_date_error"));
      }

      if (this.formMode == "edit") {
        this.updateData();
      } else {
        this.addNew();
      }
    },
    fetchClientsListDebounced() {
      if (!this.search_client || typeof this.search_client == "object") {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/clients/search?" +
            (this.search_client
              ? "&search=" + encodeURIComponent(this.search_client)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.company_client_names = data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchPropertiesListDebounced() {
      if (!this.search_property || typeof this.search_property == "object") {
        return;
      }

      axios
        .get(
          API_BASE_URL +
            "/properties/?" +
            (this.search_property
              ? "&search=" + encodeURIComponent(this.search_property)
              : ""),
          { headers: this.header }
        )
        .then(({ data }) => {
          this.properties = data.data || [];
        })
        .catch(() => {})
        .finally(() => {});
    },
    fetchPropertiesOnCreate() {
      axios
        .get(API_BASE_URL + "/properties", { headers: this.header })
        .then(({ data }) => {
          this.properties = data.data || [];
          if (
            this.formMode === "add" &&
            !this.form.property &&
            !this.form.property_id &&
            this.properties.length > 0
          ) {
            this.form.property = this.properties[0];
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    cancelRental() {
      this.$store.commit("setRentalVehicleForm", false);
      this.removeRentalInfo();
    },
    removeRentalInfo() {
      this.$store.commit("setRentalId", null);
      this.company_client_names = [];
      this.properties = [];
      this.autocompleteValueLocal = false;
      this.search_client = null;
      this.search_property = null;
      this.is_boxes = this.getCompanyPropertyFromLocalStorage(
        "boxes_on_fields",
        1
      );
      this.form.start_date = new Date().toISOString().substr(0, 10);
      this.attachmentDialog = false;
      this.form = {};
      this.$router.push("/property-rentals");
    },
  },
  watch: {
    search_client(val) {
      if (!val || this.client_id == val) {
        return;
      }
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.fetchClientsListDebounced();
      }, 500);
    },
    search_property(val) {
      if (!val || this.property_id == val) {
        return;
      }
      clearTimeout(this._propertySearchTimerId);
      this._propertySearchTimerId = setTimeout(() => {
        this.fetchPropertiesListDebounced();
      }, 500);
    },
    "form.property"(val) {
      if (!val) {
        this.form.property_id = null;
        this.form.property_name = null;
        return;
      }
      if (typeof val === "string") {
        this.form.property_id = null;
        this.form.property_name = val;
        return;
      }
      this.form.property_id = val.id || null;
      this.form.property_name = this.getPropertyName(val);
    },
  },
  computed: {
    addRentalVehicleFormActive() {
      return this.$store.state.addRentalVehicleFormActive;
    },
    formMode() {
      return this.$route.path.includes("edit") ? "edit" : "add";
    },
    today() {
      return new Date().toISOString().substr(0, 10);
    },
  },
};
</script>

<style scoped>
.rental-contract-from {
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  margin-top: 30px;
}

.attachment-title {
  position: relative;
  background: #fff;
  z-index: 0;
}

.attachment-title:after {
  content: "";
  width: Calc(100% + 10px);
  height: 1px;
  display: block;
  background: rgba(0, 0, 0, 0.42);
  position: absolute;
  top: 50%;
  left: -5px;
  z-index: -1;
}

.attachment-title span {
  background: #fff;
  display: inline-block;
  width: initial;
  position: relative;
  z-index: 0;
  padding: 0 5px;
}

.print-btn {
  background-color: #fff !important;
  border: 1px solid;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}

.v-select__slot {
  border: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-bottom: 0;
}

.v-select__selections {
  border-right: 1px solid rgba(0, 0, 0, 0.42) !important;
}

.contract-btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.contract-btn button {
  font-size: 10px !important;
}
</style>
